import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
var _excluded = ["message"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import debounce from 'lodash/debounce';
import { usePublisher } from '@magalu/mixer-publisher';
import { useAdsEvents, useAdsFillrateEvents, useCart, useWishlistProvider } from '@magalu/mixer-graphql';
import { cartRedirect, cookiesConstants, getCookie, setCookie, getFullTitle, parsePath, parseTextHighlight, routePush, sponsoredProducts, removeCookie, getCouponData, ADD_TO_BAG, whereAmI, ONE_TOUCH, usePrebasketToggle } from '@magalu/mixer-utils';
import { buildWishListActions, ADS, SPONSORED } from '../../../commons';
import useAdsSdk from '../MagaluAdsShowcase/hooks/useAdsSdk';
import useValidationCookie from '../../../hooks/useValidationCookie';
import { getProductPrice } from '../../../commons/getProductPrice';
import { parseEcommerceProductId } from '../../../commons/product';
var PRODUCTLIST_SELECT_ITEM_CLICK = 'productlist:selectItem:click';
function buildOrderedQuery(_ref) {
  var hasSponsoredAds = _ref.hasSponsoredAds,
    _ref$otherParams = _ref.otherParams,
    otherParams = _ref$otherParams === void 0 ? [] : _ref$otherParams,
    seller = _ref.seller;
  var queryParts = [];
  if (hasSponsoredAds) queryParts.push([ADS, SPONSORED]);
  queryParts.push.apply(queryParts, _toConsumableArray(otherParams));
  if (seller) queryParts.push(['seller_id', seller]);
  return queryParts.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
  }).join('&');
}
function extractRemainingParams(rawUrl, customBasePath, domain) {
  try {
    var parsedUrl = new URL(rawUrl, customBasePath || domain);
    return Array.from(parsedUrl.searchParams.entries()).filter(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        param = _ref5[0];
      return param !== ADS && param !== 'seller_id';
    });
  } catch (_unused) {
    var normalizedPath = parsePath(rawUrl);
    var _normalizedPath$split = normalizedPath.split('?'),
      _normalizedPath$split2 = _slicedToArray(_normalizedPath$split, 2),
      _normalizedPath$split3 = _normalizedPath$split2[1],
      searchParams = _normalizedPath$split3 === void 0 ? '' : _normalizedPath$split3;
    var params = new URLSearchParams(searchParams);
    return Array.from(params.entries()).filter(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 1),
        param = _ref7[0];
      return param !== ADS && param !== 'seller_id';
    });
  }
}
function extractPathname(path, customBasePath, domain) {
  try {
    var parsedUrl = new URL(path, customBasePath || domain);
    return parsedUrl.pathname;
  } catch (_unused2) {
    return parsePath(path).split('?')[0];
  }
}
function buildProductUrl(_ref8) {
  var _product$ads;
  var path = _ref8.path,
    product = _ref8.product,
    seller = _ref8.seller,
    customBasePath = _ref8.customBasePath,
    domain = _ref8.domain;
  var remainingParams = extractRemainingParams(path, customBasePath, domain);
  var queryString = buildOrderedQuery({
    hasSponsoredAds: !!(product == null ? void 0 : (_product$ads = product.ads) == null ? void 0 : _product$ads.sponsored),
    otherParams: remainingParams,
    seller: seller
  });
  var pathname = extractPathname(path, customBasePath, domain);
  return parsePath("".concat(pathname).concat(queryString ? "?".concat(queryString) : ''));
}
function extractColorVariations(thumbnails) {
  return thumbnails == null ? void 0 : thumbnails.reduce(function (acc, item) {
    return (item == null ? void 0 : item.type) === 'color' ? [].concat(_toConsumableArray(acc), [_extends({}, item, {
      available: true
    })]) : acc;
  }, []);
}
function parseProductList(_ref9) {
  var page = _ref9.page,
    pageSize = _ref9.pageSize,
    inCashDescription = _ref9.inCashDescription,
    _ref9$isOnWishlist = _ref9.isOnWishlist,
    isOnWishlist = _ref9$isOnWishlist === void 0 ? function () {} : _ref9$isOnWishlist,
    products = _ref9.products,
    sellerId = _ref9.sellerId,
    customBasePath = _ref9.customBasePath,
    domain = _ref9.domain,
    _ref9$cartData = _ref9.cartData,
    cartData = _ref9$cartData === void 0 ? {} : _ref9$cartData;
  return products == null ? void 0 : products.map(function (product, index) {
    var _product$ads2, _product$seller, _product$seller2;
    var path = product.path,
      price = product.price,
      thumbnails = product.thumbnails;
    var favoredProduct = !!isOnWishlist(product.variationId);
    var colorVariations = extractColorVariations(thumbnails);
    var variationsValues = colorVariations == null ? void 0 : colorVariations.flatMap(function (item) {
      return item == null ? void 0 : item.value;
    });
    var parsedAttributes = [{
      label: 'Cor',
      type: 'color',
      values: variationsValues
    }];
    var isSponsoredWithAdsSeller = !!((product == null ? void 0 : (_product$ads2 = product.ads) == null ? void 0 : _product$ads2.sponsored) && (product == null ? void 0 : product.adsSellerId));
    var baseSeller = sellerId || (product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.id);
    var url = "".concat(customBasePath).concat(buildProductUrl({
      customBasePath: customBasePath,
      domain: domain,
      path: path,
      product: product,
      seller: isSponsoredWithAdsSeller ? undefined : baseSeller
    }));
    var urlRedirect = "".concat(customBasePath).concat(buildProductUrl({
      customBasePath: customBasePath,
      domain: domain,
      path: path,
      product: product,
      seller: isSponsoredWithAdsSeller ? product.adsSellerId : baseSeller
    }));
    var calculatedPosition = (page - 1) * pageSize + (index + 1);
    var normalizedId = parseEcommerceProductId(product);
    return _extends({}, product, {
      description: (product == null ? void 0 : product.description) || (product == null ? void 0 : product.title),
      id: normalizedId,
      inBagQuantity: parseInt(cartData == null ? void 0 : cartData[product == null ? void 0 : product.variationId], 10),
      isOnWishlist: favoredProduct,
      minimumOrderQuantity: (product == null ? void 0 : product.minimumOrderQuantity) || 1,
      parsedAttributes: parsedAttributes,
      position: calculatedPosition,
      price: _extends({}, price, {
        paymentMethodDescription: inCashDescription || (price == null ? void 0 : price.paymentMethodDescription)
      }),
      tagCoupon: getCouponData(product == null ? void 0 : (_product$seller2 = product.seller) == null ? void 0 : _product$seller2.tags),
      thumbnails: colorVariations,
      title: getFullTitle(product),
      url: url,
      urlRedirect: urlRedirect
    });
  });
}
function parseNotFoundList(_ref10) {
  var _ref10$notFound = _ref10.notFound,
    _ref10$notFound$messa = _ref10$notFound.message,
    message = _ref10$notFound$messa === void 0 ? '' : _ref10$notFound$messa,
    remaining = _objectWithoutProperties(_ref10$notFound, _excluded);
  return _extends({
    message: parseTextHighlight(message, 'query')
  }, remaining);
}
function useProductList(_ref11) {
  var _data$search;
  var _ref11$data = _ref11.data,
    data = _ref11$data === void 0 ? {} : _ref11$data,
    _ref11$static = _ref11["static"],
    staticProps = _ref11$static === void 0 ? {} : _ref11$static,
    _ref11$structure = _ref11.structure,
    structureProps = _ref11$structure === void 0 ? {} : _ref11$structure;
  if (!data) {
    return null;
  }
  var adsPath = staticProps.adsPath,
    _staticProps$display = staticProps.display,
    initialDisplay = _staticProps$display === void 0 ? 'gallery' : _staticProps$display,
    staticDomain = staticProps.domain,
    inCashDescription = staticProps.inCashDescription,
    _staticProps$label = staticProps.label,
    label = _staticProps$label === void 0 ? 'Ofertas do Dia' : _staticProps$label,
    _staticProps$position = staticProps.position,
    listPosition = _staticProps$position === void 0 ? 1 : _staticProps$position,
    _staticProps$notFound = staticProps.notFound,
    notFound = _staticProps$notFound === void 0 ? {} : _staticProps$notFound,
    _staticProps$origin = staticProps.origin,
    origin = _staticProps$origin === void 0 ? 'doory' : _staticProps$origin,
    _staticProps$pageSize = staticProps.pageSize,
    pageSize = _staticProps$pageSize === void 0 ? 20 : _staticProps$pageSize,
    _staticProps$showWish = staticProps.showWishBtn,
    showWishBtn = _staticProps$showWish === void 0 ? false : _staticProps$showWish,
    _staticProps$spa = staticProps.spa,
    spa = _staticProps$spa === void 0 ? false : _staticProps$spa,
    _staticProps$customBa = staticProps.customBasePath,
    customBasePath = _staticProps$customBa === void 0 ? '' : _staticProps$customBa,
    _staticProps$shouldIn = staticProps.shouldInitSdk,
    shouldInitSdk = _staticProps$shouldIn === void 0 ? false : _staticProps$shouldIn,
    _staticProps$context = staticProps.context,
    context = _staticProps$context === void 0 ? {} : _staticProps$context;
  var asPath = structureProps.asPath,
    _structureProps$confi = structureProps.config,
    _structureProps$confi2 = _structureProps$confi === void 0 ? {} : _structureProps$confi,
    cartUrl = _structureProps$confi2.cartUrl,
    structureDomain = _structureProps$confi2.domain,
    cookieDomain = _structureProps$confi2.cookieDomain,
    salesChannelId = _structureProps$confi2.salesChannelId,
    _structureProps$cooki = structureProps.cookies,
    _structureProps$cooki2 = _structureProps$cooki === void 0 ? {} : _structureProps$cooki,
    accountData = _structureProps$cooki2.accountData,
    customerId = _structureProps$cooki2.customerId,
    location = _structureProps$cooki2.location,
    device = structureProps.device,
    name = structureProps.name,
    _structureProps$route = structureProps.route,
    route = _structureProps$route === void 0 ? {} : _structureProps$route,
    resolvedUrl = structureProps.resolvedUrl;
  var ML2_SID = cookiesConstants.ML2_SID,
    MLPARCEIRO = cookiesConstants.MLPARCEIRO;
  var category = data == null ? void 0 : data.category;
  var search = (_data$search = data == null ? void 0 : data.search) !== null && _data$search !== void 0 ? _data$search : {};
  var initialProducts = search.products;
  var abTesting = search.abTesting,
    attributionToken = search.attributionToken,
    pagination = search.pagination;
  var isMobile = device === 'mobile';
  var cartId = getCookie(ML2_SID);
  var enabledPrebasket = usePrebasketToggle();
  var _useState = useState(initialDisplay),
    _useState2 = _slicedToArray(_useState, 2),
    display = _useState2[0],
    setDisplay = _useState2[1];
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useCart = useCart(),
    _useCart2 = _slicedToArray(_useCart, 1),
    _useCart2$ = _useCart2[0],
    addToCart = _useCart2$.addToCart,
    getCart = _useCart2$.getCart,
    removeItem = _useCart2$.removeItem;
  useValidationCookie(cartId, cookieDomain);
  var cartRef = useRef(null);
  var bagCountRef = useRef(0);
  var productIdRef = useRef('');
  useEffect(function () {
    if (whereAmI.onClient) {
      var _JSON$parse;
      var storedCart = localStorage.getItem('cart');
      cartRef.current = storedCart ? JSON.parse(storedCart) : {};
      var storedBagCount = localStorage.getItem('bagCount');
      bagCountRef.current = storedBagCount ? ((_JSON$parse = JSON.parse(storedBagCount)) == null ? void 0 : _JSON$parse.value) || 0 : 0;
    }
  }, []);
  var syncCartToStorage = useCallback(function (cart) {
    cartRef.current = cart;
    localStorage.setItem('cart', JSON.stringify(cart));
  }, []);
  var syncBagCountToStorage = useCallback(function (itemsQuantity) {
    var count = parseInt(itemsQuantity, 10);
    bagCountRef.current = count;
    localStorage.setItem('bagCount', JSON.stringify({
      value: count
    }));
    window.dispatchEvent(new CustomEvent('local-storage-change', {
      detail: {
        itemId: 'value',
        storageKey: 'bagCount',
        value: count
      }
    }));
  }, []);
  var _useAdsFillrateEvents = useAdsFillrateEvents(),
    sendAdsFillrate = _useAdsFillrateEvents.sendAdsFillrate;
  var _useAdsEvents = useAdsEvents({
      adsPath: adsPath,
      customerId: customerId,
      data: {
        category: category
      },
      structure: {
        device: device,
        name: name,
        route: route
      }
    }),
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents,
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents;
  var _useWishlistProvider = useWishlistProvider(),
    addToWishlist = _useWishlistProvider.addToWishlist,
    removeFromWishlist = _useWishlistProvider.removeFromWishlist,
    updateWishlist = _useWishlistProvider.updateWishlist,
    isOnWishlist = _useWishlistProvider.isOnWishlist;
  var filters = route.filters,
    _route$page = route.page,
    page = _route$page === void 0 ? 1 : _route$page,
    sellerId = route.sellerId,
    term = route.term,
    bypass = route.bypass,
    selectionId = route.selectionId;
  var domain = staticDomain || structureDomain;
  var showWishilistButton = showWishBtn;
  var ML_EXP = cookiesConstants.ML_EXP;
  var actualPageSize = (pagination == null ? void 0 : pagination.size) || pageSize;
  var routerCategory = structureProps.route || {};
  var list = (routerCategory == null ? void 0 : routerCategory.slug1) || (routerCategory == null ? void 0 : routerCategory.categorySlug) || name || 'null';
  var listValue = name === 'selecao' && selectionId ? selectionId : list;
  var eventData = {
    abTesting: abTesting,
    attributionToken: attributionToken,
    category: category,
    customer_id: accountData == null ? void 0 : accountData.customer_id,
    display: display,
    filters: filters,
    list: listValue,
    listPosition: listPosition,
    offset: ((pagination == null ? void 0 : pagination.page) - 1) * actualPageSize,
    origin: origin,
    pageName: name,
    term: route.term
  };
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentNode = _useState4[0],
    setCurrentNode = _useState4[1];
  var productsNotFound = parseNotFoundList({
    notFound: notFound
  });
  var getInitialCartData = function getInitialCartData() {
    if (whereAmI.onClient) {
      var storedCart = localStorage.getItem('cart');
      return storedCart ? JSON.parse(storedCart) : {};
    }
    return {};
  };
  var _useState5 = useState(function () {
      return parseProductList({
        cartData: getInitialCartData(),
        customBasePath: customBasePath,
        domain: domain,
        inCashDescription: inCashDescription,
        page: page,
        pageSize: actualPageSize,
        products: initialProducts,
        sellerId: sellerId
      });
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    products = _useState6[0],
    setProducts = _useState6[1];
  var adsProducts = sponsoredProducts(products);
  var updateProducts = function updateProducts() {
    return setProducts(parseProductList({
      cartData: cartRef.current || {},
      customBasePath: customBasePath,
      domain: domain,
      inCashDescription: inCashDescription,
      isOnWishlist: isOnWishlist,
      page: page,
      pageSize: actualPageSize,
      products: initialProducts,
      sellerId: sellerId
    }));
  };
  function normalizeAdsFillRateEvent() {
    var _ref12, _route$categorySlug, _window, _window$location, _category$, _category$2;
    var fillrates = [];
    var _search$adsFillRate = search.adsFillRate,
      eventId = _search$adsFillRate.eventId,
      placement = _search$adsFillRate.placement,
      requested = _search$adsFillRate.requested,
      received = _search$adsFillRate.received;
    var searchTerm = (_ref12 = (_route$categorySlug = route.categorySlug) !== null && _route$categorySlug !== void 0 ? _route$categorySlug : term) !== null && _ref12 !== void 0 ? _ref12 : '';
    fillrates.push({
      adType: 'SPONSORED_PRODUCT',
      channel: context.channel,
      eventId: eventId,
      page: (context == null ? void 0 : context.page) || "UNKNOWN_WEB_".concat((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.href),
      placement: placement,
      received: {
        categories: [].concat(_toConsumableArray(new Set(adsProducts.map(function (product) {
          var _product$category;
          return (_product$category = product.category) == null ? void 0 : _product$category.id;
        }))), _toConsumableArray(new Set(adsProducts.map(function (product) {
          var _product$subcategory;
          return (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.id;
        })))),
        clientAdsAmount: adsProducts.length,
        serverAdsAmount: received.serverAdsAmount,
        skus: _toConsumableArray(new Set(adsProducts.map(function (_ref13) {
          var id = _ref13.id;
          return id;
        })))
      },
      requested: {
        categories: (category == null ? void 0 : (_category$ = category[0]) == null ? void 0 : _category$.id) ? [category == null ? void 0 : (_category$2 = category[0]) == null ? void 0 : _category$2.id] : [''],
        clientAdsAmount: requested.clientAdsAmount,
        serverAdsAmount: requested.serverAdsAmount
      },
      searchTerm: searchTerm
    });
    return fillrates;
  }
  function handleExperimentCookie() {
    if (bypass) return;
    var currentExperiment = getCookie(ML_EXP);
    var hasDiffInExperiment = (abTesting == null ? void 0 : abTesting.experimentName) !== currentExperiment;
    if (abTesting == null ? void 0 : abTesting.id) {
      if (!currentExperiment || hasDiffInExperiment) {
        setCookie({
          domain: cookieDomain,
          name: ML_EXP,
          value: abTesting == null ? void 0 : abTesting.experimentName
        });
        publish('productlist:start:experiment', {
          abTesting: abTesting
        });
      }
    } else {
      removeCookie(ML_EXP, cookieDomain, '/');
    }
  }
  function handleProductMouseDown(e, product) {
    var _product$ads3;
    if (product == null ? void 0 : (_product$ads3 = product.ads) == null ? void 0 : _product$ads3.sponsored) {
      sendAdsClickEvents([_extends({}, product.ads, {
        adType: 'SPONSORED_PRODUCT'
      })]);
    } else if (route == null ? void 0 : route.track_id) {
      sendAdsClickEvents([{
        additionalAttribution: {
          id: product.id,
          type: 'product'
        },
        adType: 'SPONSORED_PRODUCT',
        trackId: route.track_id
      }]);
    }
  }
  var showAddToCartButton = function showAddToCartButton(product) {
    var _product$subcategory2;
    var denyListsubCategoryIds = ['CRED', 'SEGR', 'SPEP', 'SMOV', 'STAV', 'SARV', 'SEIF', 'SELA', 'SVAU', 'PEET', 'SPSD', 'SGRS', 'REFR', 'FORN', 'MOND', 'LALO', 'ELA1', 'LAVA', 'MMLP', 'SELT', 'FREE', 'CEDO', 'ADEG', 'ARAR'];
    var isDenyListed = denyListsubCategoryIds.indexOf(product == null ? void 0 : (_product$subcategory2 = product.subcategory) == null ? void 0 : _product$subcategory2.id) !== -1;
    return !isDenyListed;
  };
  var debouncedHandleCart = useMemo(function () {
    return debounce(function () {
      var _ref14 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(product, productId, quantity, rollback, variables) {
        var currentCart, previousQuantity, isAddingNewItemToCart, _product$seller3, _yield$removeItem, _error, cartValues, itemsQuantity, _yield$addToCart, addToCartData, error, rollbackCart, _cartData$totals, _yield$getCart, cartData, _addToCartData$totals;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              currentCart = _extends({}, cartRef.current || {});
              previousQuantity = currentCart[productId];
              isAddingNewItemToCart = previousQuantity === undefined;
              if (!(quantity === '0' && previousQuantity === undefined)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              if (!(quantity === '0')) {
                _context.next = 22;
                break;
              }
              if (Object.prototype.hasOwnProperty.call(currentCart, productId)) {
                delete currentCart[productId];
              }
              cartRef.current = currentCart;
              _context.next = 10;
              return removeItem({
                id: variables == null ? void 0 : variables.id,
                productId: productId,
                seller: product == null ? void 0 : (_product$seller3 = product.seller) == null ? void 0 : _product$seller3.id,
                stwu: customerId
              }, {
                loading: false
              });
            case 10:
              _yield$removeItem = _context.sent;
              _error = _yield$removeItem.error;
              if (!_error) {
                _context.next = 16;
                break;
              }
              if (previousQuantity !== undefined) {
                cartRef.current = _extends({}, cartRef.current, _defineProperty({}, productId, previousQuantity));
              }
              rollback();
              return _context.abrupt("return");
            case 16:
              syncCartToStorage(currentCart);
              cartValues = Object.values(currentCart);
              itemsQuantity = cartValues.length > 0 ? cartValues.reduce(function (acc, it) {
                return parseInt(acc, 10) + parseInt(it, 10);
              }, 0) : 0;
              syncBagCountToStorage(itemsQuantity);
              publish('product:removeFromCart', _extends({}, eventData, {
                cartId: variables == null ? void 0 : variables.id,
                product: _extends({}, product),
                quantity: variables == null ? void 0 : variables.quantity,
                typeButton: ADD_TO_BAG
              }));
              return _context.abrupt("return");
            case 22:
              currentCart[productId] = String(quantity);
              cartRef.current = currentCart;
              if (isAddingNewItemToCart) {
                handleProductMouseDown(null, product);
              }
              _context.next = 27;
              return addToCart(variables, {
                loading: false,
                updatePreBasket: enabledPrebasket && !isAddingNewItemToCart
              });
            case 27:
              _yield$addToCart = _context.sent;
              addToCartData = _yield$addToCart.data;
              error = _yield$addToCart.error;
              if (!error) {
                _context.next = 34;
                break;
              }
              if (previousQuantity !== undefined) {
                cartRef.current = _extends({}, cartRef.current, _defineProperty({}, productId, previousQuantity));
              } else {
                rollbackCart = _extends({}, cartRef.current);
                delete rollbackCart[productId];
                cartRef.current = rollbackCart;
              }
              rollback();
              return _context.abrupt("return");
            case 34:
              syncCartToStorage(currentCart);
              if (!enabledPrebasket) {
                _context.next = 43;
                break;
              }
              _context.next = 38;
              return getCart(null, customerId);
            case 38:
              _yield$getCart = _context.sent;
              cartData = _yield$getCart.data.cart;
              syncBagCountToStorage(cartData == null ? void 0 : (_cartData$totals = cartData.totals) == null ? void 0 : _cartData$totals.itemsQuantity);
              _context.next = 44;
              break;
            case 43:
              syncBagCountToStorage(addToCartData == null ? void 0 : (_addToCartData$totals = addToCartData.totals) == null ? void 0 : _addToCartData$totals.itemsQuantity);
            case 44:
              publish('addtocart:success', {
                cartId: (addToCartData == null ? void 0 : addToCartData.cartId) || cartId,
                channel: salesChannelId || '',
                location: location,
                product: product,
                typeButton: ONE_TOUCH
              });
              publish(PRODUCTLIST_SELECT_ITEM_CLICK, _extends({}, eventData, product));
              publish('productlist:click', _extends({}, eventData, product));
              publish('product:addToCart', _extends({}, eventData, {
                cartId: (addToCartData == null ? void 0 : addToCartData.cartId) || cartId,
                product: _extends({}, product),
                quantity: variables == null ? void 0 : variables.quantity,
                typeButton: ADD_TO_BAG
              }));
            case 48:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3, _x4, _x5) {
        return _ref14.apply(this, arguments);
      };
    }(), 600);
  }, []);
  var handleAddToCart = function handleAddToCart(product, productId, quantity, rollback) {
    try {
      var _product$seller4;
      var variables = {
        channelId: salesChannelId,
        extensions: false,
        id: getCookie(ML2_SID),
        item: {
          id: productId,
          price: getProductPrice(product),
          title: product == null ? void 0 : product.title
        },
        partnerId: getCookie(MLPARCEIRO),
        productId: productId,
        quantity: quantity,
        sellerId: product == null ? void 0 : (_product$seller4 = product.seller) == null ? void 0 : _product$seller4.id,
        services: [],
        stwu: customerId
      };
      if (productId !== productIdRef.current) {
        productIdRef.current = productId;
        debouncedHandleCart.flush();
      }
      debouncedHandleCart(product, productId, quantity, rollback, variables);
      return {
        status: 'OK'
      };
    } catch (error) {
      return null;
    }
  };
  useEffect(function () {
    if (isMobile && search.viewMode !== null) {
      setDisplay(search.viewMode);
    }
    if (showWishilistButton) {
      _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", updateWishlist());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
    _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            updateProducts();
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
    handleExperimentCookie();
    subscribe('productlist:display:change', function (_ref17) {
      var id = _ref17.id;
      return setDisplay(id);
    });
    publish('productlist:impression', _extends({}, eventData, {
      products: products
    }));
    if (search.adsFillRate) {
      var fillrates = normalizeAdsFillRateEvent();
      sendAdsFillrate(fillrates);
    }
    return function () {
      unsubscribe('productlist:display:change', function (_ref18) {
        var id = _ref18.id;
        return setDisplay(id);
      });
    };
  }, [asPath, JSON.stringify(route)]);
  var isEmptyList = !(products == null ? void 0 : products.length) && productsNotFound;
  function handleProductView(product) {
    var _product$ads4;
    publish('product:view', _extends({}, eventData, {
      product: _extends({}, product, {
        position: (product == null ? void 0 : product.index) + 1
      })
    }));
    publish('product:viewItemList', _extends({}, eventData, product));
    if (product == null ? void 0 : (_product$ads4 = product.ads) == null ? void 0 : _product$ads4.sponsored) {
      sendAdsImpressionEvents([_extends({}, product.ads, {
        adType: 'SPONSORED_PRODUCT'
      })]);
    }
  }
  function handleProductClick(e, product) {
    e.stopPropagation();
    e.preventDefault();
    publish(PRODUCTLIST_SELECT_ITEM_CLICK, _extends({}, eventData, product));
    publish('productlist:click', _extends({}, eventData, product));
    routePush({
      path: product == null ? void 0 : product.urlRedirect,
      spa: spa
    });
  }
  function handleThumbnailClick(e, product, variation) {
    e.stopPropagation();
    e.preventDefault();
    var productWithNormalizedId = _extends({}, product, variation, {
      id: parseEcommerceProductId(variation || product)
    });
    publish(PRODUCTLIST_SELECT_ITEM_CLICK, _extends({}, eventData, productWithNormalizedId));
    publish('variation:click', _extends({}, eventData, productWithNormalizedId));
    routePush({
      path: "/".concat(product == null ? void 0 : product.path),
      spa: spa
    });
  }
  function handleListShowMore() {
    publish('productlist:showmore', {
      eventLabel: label
    });
  }
  function handleAddToWishlist(_x6, _x7) {
    return _handleAddToWishlist.apply(this, arguments);
  }
  function _handleAddToWishlist() {
    _handleAddToWishlist = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(e, product) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            e.stopPropagation();
            e.preventDefault();
            if (!(accountData == null ? void 0 : accountData.id)) {
              _context4.next = 9;
              break;
            }
            if (!isOnWishlist(product == null ? void 0 : product.variationId)) {
              publish('addToWishlist:click', _extends({}, eventData, product));
            }
            if (isOnWishlist(product == null ? void 0 : product.variationId)) {
              publish('removeFromWishList:click', _extends({}, eventData, product));
            }
            _context4.next = 7;
            return buildWishListActions({
              addToWishlist: addToWishlist,
              publish: publish,
              removeFromWishlist: removeFromWishlist,
              shouldUpdateHeart: updateProducts
            })({
              customerId: accountData == null ? void 0 : accountData.id,
              isLiked: product == null ? void 0 : product.isOnWishlist,
              product: product
            });
          case 7:
            _context4.next = 10;
            break;
          case 9:
            cartRedirect({
              cartUrl: cartUrl,
              next: "".concat(domain).concat(asPath),
              type: 'login'
            });
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _handleAddToWishlist.apply(this, arguments);
  }
  var ref = useCallback(function (node) {
    if (node !== null) {
      setCurrentNode(node);
    }
  }, []);
  useEffect(function () {
    var parsedProducts = parseProductList({
      cartData: cartRef.current || {},
      customBasePath: customBasePath,
      domain: domain,
      inCashDescription: inCashDescription,
      isOnWishlist: isOnWishlist,
      page: page,
      pageSize: actualPageSize,
      products: initialProducts,
      sellerId: sellerId
    });
    if ((parsedProducts == null ? void 0 : parsedProducts.length) && shouldInitSdk && currentNode) {
      var uriOrTerm = term ? {
        searchTerm: term
      } : {
        pageUri: resolvedUrl
      };
      var flattenedAndParsedAds = adsProducts == null ? void 0 : adsProducts.flatMap(function (item) {
        return _extends({}, item.ads, {
          adId: item.ads.id,
          name: item.title,
          publisherId: context.publisherId,
          sellerId: item.seller.id,
          type: 'SPONSORED_PRODUCT'
        });
      });
      useAdsSdk(_extends({}, context, uriOrTerm, {
        target: currentNode
      }), flattenedAndParsedAds);
    }
  }, [currentNode]);
  return {
    display: display,
    domain: domain,
    handleAddToCart: handleAddToCart,
    handleAddToWishlist: handleAddToWishlist,
    handleListShowMore: handleListShowMore,
    handleProductClick: handleProductClick,
    handleProductMouseDown: handleProductMouseDown,
    handleProductView: handleProductView,
    handleThumbnailClick: handleThumbnailClick,
    isEmptyList: isEmptyList,
    products: products,
    ref: ref,
    showAddToCartButton: showAddToCartButton,
    showWishilistButton: showWishilistButton
  };
}
export default useProductList;